// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .spinner-container{align-items:center;background-color:transparent;bottom:0;display:flex;justify-content:center;left:0;max-height:100%;position:absolute;right:0;top:0;z-index:9}#openbay .spinner-container.position-relative{padding:2rem 0}#openbay .spinner-border{color:#e83c79}#openbay .spinner-border-lg{height:4rem;width:4rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
